import { Timer } from '@cds/scoreboards/v1/shared';
import { EventScoreboard } from '@frontend/sports/betting-offer/feature/model';

export class IncreaseTimer {
    base: number;
    seconds: number;
    running: boolean;
    visible: boolean;

    tickTime = 1000;

    static fromScoreboardTimer(s: Timer): IncreaseTimer | null {
        if (!s) {
            return null;
        }
        const timer = new IncreaseTimer();
        timer.base = new Date(s.base).getTime();
        timer.running = s.running;
        timer.seconds = s.seconds;
        timer.visible = s.visible;

        return timer;
    }

    getDisplay(): string {
        const now = new Date();
        const timeDiff = Math.max(0, Math.floor((now.getTime() - this.base) / 1000) + this.seconds);

        const seconds = this.running ? timeDiff : this.seconds;
        const displayedMinutes = Math.floor(seconds / 60);
        const displayedseconds = seconds % 60;

        return displayedMinutes + ':' + (displayedseconds < 10 ? '0' + displayedseconds : displayedseconds.toString());
    }
}

export class DecreaseTimer {
    static countDownMinutesBeforeGame = 60;

    future: Date;
    running: boolean;
    tickTime = 60000;

    static fromDate(futureDate: Date): DecreaseTimer {
        const timer = new DecreaseTimer();
        timer.future = futureDate;
        const now = new Date();
        timer.running = futureDate > now;

        return timer;
    }

    get activeTime(): number {
        const minutesLeft = this.getMinutesLeft();
        if (0 < minutesLeft && minutesLeft < DecreaseTimer.countDownMinutesBeforeGame) {
            return minutesLeft;
        } else {
            return 0;
        }
    }

    getMinutesLeft(): number {
        if (!this.running) {
            return 0;
        }
        const now = new Date();
        const timeDiff = Math.max(0, Math.ceil((this.future.getTime() - now.getTime()) / 1000));
        if (timeDiff === 0) {
            this.running = false;

            return 0;
        }

        return Math.ceil(timeDiff / 60);
    }
}

export class ScoreboardTimer {
    eventStartDate: Date;
    private indicator: string | null;

    private elapsedTimer: IncreaseTimer | null;
    countDownTimer: DecreaseTimer | null;

    constructor(
        startTime: Date,
        private scoreboard: EventScoreboard,
    ) {
        this.eventStartDate = startTime;
        this.countDownTimer = scoreboard.started ? null : DecreaseTimer.fromDate(this.eventStartDate);
        this.indicator = scoreboard.started ? scoreboard.timeIndicator || null : null;
        this.elapsedTimer = scoreboard.started && scoreboard.timer ? IncreaseTimer.fromScoreboardTimer(scoreboard.timer) : null;
    }

    getTimeMyBets(eventStartingInText: string): string {
        if (this.indicator) {
            return this.indicator;
        }
        if (this.elapsedTimer && this.elapsedTimer.visible && this.scoreboard.timerRunning) {
            return this.elapsedTimer.getDisplay();
        }

        return eventStartingInText;
    }

    shouldBeVisible(): boolean {
        return !!(
            (this.countDownTimer && this.countDownTimer.activeTime > 0) ||
            this.indicator ||
            (this.elapsedTimer && this.elapsedTimer.visible && this.elapsedTimer.running)
        );
    }
}
